import { Chip } from "./components/chipsParts.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
const ChipsWithIconControlled = ({
  text,
  color,
  icon,
  size
}) => {
  return /* @__PURE__ */jsxs(Chip, {
    backgroundColor: color,
    circular: true,
    size,
    children: [icon ? /* @__PURE__ */jsx(Chip.Icon, {
      y: -1,
      scaleIcon: 1.1,
      color: "$color9",
      children: icon
    }) : null, /* @__PURE__ */jsx(Chip.Text, {
      color: "white",
      fontWeight: 500,
      fontSize: 11,
      children: text
    })]
  });
};
export { ChipsWithIconControlled };
//# sourceMappingURL=ChipsWithIcon.mjs.map
